import { post } from "@shared/utils/server";

export async function updateGameFavoriteStatus(gameId, isFavorite) {
  return await post({
    method: "Game.updateFavoriteStatus",
    args: {
      game_id: gameId,
      is_favorite: isFavorite,
    },
  });
}

export async function noWagerGames() {
  return await post({
    method: "Game.listNoWager",
    args: {},
  });
}

export async function noJackpotGames() {
  return await post({
    method: "Game.listNoJackpot",
    args: {},
  });
}
